import { Directive, HostBinding, Input } from '@angular/core';

@Directive({
  selector: '[pgLabel], [gritLabel]',
})
export class PgLabelDirective {
  // @HostBinding('class') _classList = 'pg-label';

  @HostBinding('class.grit-label')
  @HostBinding('class.pg-label')
  _classPgLabel = true;

  @HostBinding('attr.for')
  labelFor;

  constructor() {}
}
